import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import InputUserInfo from "@/views/InputUserInfo.vue";
import { helper } from "@/helper";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    name: "InputUserInfo",
    path: "/InputUserInfo",
    component: InputUserInfo,
  },
  {
    name: "AppointmentCheckIn",
    path: "/AppointmentCheckIn",
    component: () => import("@/views/AppointmentCheckIn"),
    meta: { requiresAuth: true },
  },
  {
    name: "Enqueue",
    path: "/Enqueue",
    component: () => import("@/views/Enqueue"),
    meta: { requiresAuth: true },
  },
  {
    name: "EnqueueContent",
    path: "/EnqueueContent",
    component: () => import("@/views/EnqueueContent"),
    meta: { requiresAuth: true },
  },
  {
    name: "EnqueueInfo",
    path: "/EnqueueInfo",
    component: () => import("@/views/EnqueueInfo"),
    meta: { requiresAuth: true },
  },
  {
    name: "EnqueueCall",
    path: "/EnqueueCall",
    component: () => import("@/views/EnqueueCall"),
    meta: { requiresAuth: true },
  },
  {
    name: "CancelEnqueue",
    path: "/CancelEnqueue",
    component: () => import("@/views/CancelEnqueue"),
    meta: { requiresAuth: true },
  },
  {
    name: "CancelEnqueueSuccess",
    path: "/CancelEnqueueSuccess",
    component: () => import("@/views/CancelEnqueueSuccess"),
    meta: { requiresAuth: true },
  },
  {
    name: "Error",
    path: "/Error",
    component: () => import("@/views/Error"),
  },
  {
    name: "About",
    path: "/About",
    component: () => import("@/views/About"),
  },
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // console.log(
  //   "process.env.VUE_APP_ISDEBUGGING",
  //   process.env.VUE_APP_ISDEBUGGING
  // );
  if (process.env.VUE_APP_ISDEBUGGING) {
    console.log("to", to);
  }
  if (to.query.token) {
    const queryToken = to.query.token;
    helper.processToken(queryToken);
  }

  const userCookie = helper.getUserCookie();

  if (userCookie != null) {
    userCookie.isShowCheckinHeader =
      from.name == "AppointmentCheckIn" || from.name == "Enqueue"
        ? true
        : false;
    helper.setUserCookie(
      userCookie,
      store.getters.getConfigItem("DATA_RETENTION_PERIOD")
    );
  }

  // Check if authenticated: Only Home and InputUserInfo allow direct action.
  if (store.getters.getConfigItem("BYPASS_ALL_AUTHENTICATION") != "true") {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      // console.log("requiresAuth. UserCookie", userCookie);

      if (userCookie == null) {
        next({
          path: "/InputUserInfo",
        });
        return;
      }
    }
  }
  // Control mode routing
  let modePath = "";
  if (store.getters.getConfigItem("MENU_MODE") == "ORGTREE") {
    modePath = "Enqueue";
  }

  if (store.getters.getConfigItem("MENU_MODE") == "CONTENT") {
    modePath = "EnqueueContent";
  }
  if (
    (to.name === "Enqueue" || to.name === "EnqueueContent") &&
    to.name !== modePath
  ) {
    // console.log("Going to Enqueue!: ", to.name, " modePath:", modePath);
    next({
      path: "/" + modePath,
    });
    return;
  }

  // If not in the above conditions, always just go to next()
  next();
});

export default router;
